import { View, Text, Image } from "@react-pdf/renderer";
import { parseDate } from "helpers/date";
import { IAbnNotice } from "types/AbnNotice/AbnNotice";

import { styles } from "../styles";

/**
 * CLE-2659: signature block and statutory footer of CMS-R-131 (Exp. 03/31/2029).
 *
 * The accessibility notice and PRA disclosure are reproduced verbatim from the form — they are
 * required boilerplate, not our copy, so do not reword them.
 */
export function Signature({
  activeAbnNotice,
}: {
  activeAbnNotice?: IAbnNotice | null;
}) {
  return (
    <View style={{ marginTop: 6, display: "flex", flexDirection: "column" }}>
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          borderTopWidth: 1,
          borderBottomWidth: 1,
          borderColor: "#000",
          minHeight: 46,
        }}
      >
        <View
          style={{
            width: "65%",
            borderRightWidth: 1,
            borderColor: "#000",
            padding: 4,
          }}
        >
          <Text
            style={{
              ...styles.bodyText,
              fontSize: 11,
              fontFamily: "Helvetica-Bold",
              marginBottom: 2,
            }}
          >
            Signature
          </Text>
          {activeAbnNotice?.signatureUrl && (
            <Image
              style={{ width: 100, height: "auto" }}
              src={activeAbnNotice?.signatureUrl}
            />
          )}
        </View>
        <View style={{ width: "35%", padding: 4 }}>
          <Text style={{ ...styles.bodyText, fontSize: 11, marginBottom: 2 }}>
            <Text style={{ fontFamily: "Helvetica-Bold" }}>Date </Text>
            (mm/dd/yyyy)
          </Text>
          {activeAbnNotice?.createdAt && (
            <Text style={{ ...styles.bodyText, fontSize: 11, marginBottom: 0 }}>
              {parseDate(activeAbnNotice?.createdAt)}
            </Text>
          )}
        </View>
      </View>

      <Text style={{ ...styles.bodyText, fontSize: 9, marginTop: 4 }}>
        You have the right to get Medicare information in an accessible format,
        like large print, Braille, or audio. You also have the right to file a
        complaint if you feel you&apos;ve been discriminated against. Visit{" "}
        <Text style={{ textDecoration: "underline" }}>
          Medicare.gov/about-us/accessibility-nondiscrimination-notice
        </Text>
        .
      </Text>

      <Text style={{ ...styles.bodyText, fontSize: 7, marginBottom: 4 }}>
        <Text style={{ fontFamily: "Helvetica-Bold" }}>
          PRA Disclosure Statement:{" "}
        </Text>
        According to the Paperwork Reduction Act of 1995, no persons are
        required to respond to a collection of information unless it displays a
        valid OMB control number. The valid OMB control number for this
        information collection is 0938-0566. This information collection is for
        providers, suppliers, Hospice and Religious Non-medical HealthCare
        Institutes and Home Health Agencies to notify original Medicare
        beneficiaries of their potential financial liability under specific
        conditions. The time required to complete this information collection is
        estimated to average less than 7 minutes per response, including the
        time to review instructions, search existing data resources, gather the
        data needed, to review and complete the information collection. This
        information collection is mandatory under Section 1879 of the Social
        Security Act, 42 CFR 411.404(b) and (c) and 411.408(d)(2) and (f). If
        you have comments concerning the accuracy of the time estimate(s) or
        suggestions for improving this form, please write to: CMS, 7500 Security
        Boulevard, Attn: PRA Reports Clearance Officer, Mail Stop C4-26-05,
        Baltimore, Maryland 21244-1850.
      </Text>

      <View style={{ borderTopWidth: 1, borderColor: "#000" }} />
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          marginTop: 3,
        }}
      >
        <Text style={{ ...styles.bodyText, fontSize: 9, marginBottom: 0 }}>
          Form CMS-R-131 (Exp. 03/31/2029)
        </Text>
        <Text style={{ ...styles.bodyText, fontSize: 9, marginBottom: 0 }}>
          Form Approved OMB No. 0938-0566
        </Text>
      </View>
    </View>
  );
}
